import QuillWysiwyg from 'components/ui/QuillWysiwyg';
import React, { useEffect, useState } from 'react';

interface PropTypes {
  value: string;
  onDraftChange?: (body: string) => void;
  onCommit: (body: string) => void;
}

const EmailBodyEditor = (props: PropTypes) => {
  // Keep Quill editing local so parent updates do not move the cursor.
  const [draft, setDraft] = useState(props.value || '');
  const lastSyncedValue = React.useRef(props.value || '');

  useEffect(() => {
    const value = props.value || '';
    if (value !== lastSyncedValue.current) {
      lastSyncedValue.current = value;
      setDraft(value);
    }
  }, [props.value]);

  return (
    <QuillWysiwyg
      value={draft}
      maxheight={210}
      onChange={(value, source) => {
        if (!source || source === 'user') {
          lastSyncedValue.current = value;
          setDraft(value);
          props.onDraftChange?.(value);
        }
      }}
      onBlur={props.onCommit}
      borderRadius={5}
      boxShadow="rgba(0, 0, 0, 0.1) 0px 2px 2px 0px, rgba(0, 0, 0, 0.1) 0px 2px 13px 0px"
      mentionValues={[]}
    />
  );
};

export default EmailBodyEditor;
